export enum CREDITOR_DEAL_STATUS {
  ACO_EM_ATRASO = 'ACO. EM ATRASO',
  PROM_EM_ATRASO = 'PROM. EM ATRASO',
  AC_CREDOR_EM_ATRASO = 'AC CREDOR EM ATRASO',
  PROM_CREDOR_ATRASO = 'PROM CREDOR ATRASO',
  PROM_CANCELADA = 'PROM. CANCELADA',
  PROM_CREDOR_CANC = 'PROM CREDOR CANC.',
  PROM_EM_DIA = 'PROM. EM DIA',
}

export enum STATUS_NAME_CHANGED {
  PROM_EM_DIA = 'AGUARDANDO PAGAMENTO',
  PROM_CREDOR_ATRASO = 'ACORDO ATIVO COM PARCELA EM ATRASO',
  PROM_CREDOR_CANC = 'ACORDO ROMPIDO',
}

export const statusNameChange: any = {
  [CREDITOR_DEAL_STATUS.PROM_EM_DIA]: STATUS_NAME_CHANGED.PROM_EM_DIA,
  [CREDITOR_DEAL_STATUS.PROM_CREDOR_ATRASO]:
    STATUS_NAME_CHANGED.PROM_CREDOR_ATRASO,
  [CREDITOR_DEAL_STATUS.PROM_CREDOR_CANC]: STATUS_NAME_CHANGED.PROM_CREDOR_CANC,
};

export const agreementStatusForDebts = ['PROM CREDOR ATRASO','PROM CREDOR CANC.'];
